import isNil from 'lodash/isNil';
import {AgeGradeVo} from '../../common/shared/api/gateway/enums/AgeGradeVo.enum';
import {AgeGrade} from '../generated/types';

export function createAgeGrade(ageGradeVoParam: AgeGradeVo): AgeGrade {
  if (!ageGradeVoParam) return AgeGrade.All;
  const ageGrade = ageGradeMap[ageGradeVoParam];
  return isNil(ageGrade) ? AgeGrade.Nineteen : ageGrade;
}

const ageGradeMap: {[key in AgeGradeVo]: AgeGrade} = {
  [AgeGradeVo.All]: AgeGrade.All,
  [AgeGradeVo.Eighteen]: AgeGrade.Eighteen,
  [AgeGradeVo.Fifteen]: AgeGrade.Fifteen,
  [AgeGradeVo.Nineteen]: AgeGrade.Nineteen,
};

/**
 * ItemSingleDto에서 연령정보는 회차, 시리즈 2가지가 있습니다.
 * 이 연령 정보들을 회차 -> 시리즈 순으로 우선순위를 두고 리턴합니다.
 */
export function getAgeGradeVo({
  singleAgeGrade,
  seriesAgeGrade,
}: {
  singleAgeGrade?: AgeGradeVo;
  seriesAgeGrade?: AgeGradeVo;
}) {
  return singleAgeGrade ?? seriesAgeGrade ?? AgeGradeVo.All;
}
